import * as ChartType from "../../constants/ChartType";
import {createHighPieChart} from "./HighPieChartDrawer";
import {createHighColumnsChart} from "./HighColumnsWithCategsDrawer";
import {createHighColCategLabelsChart} from "./HighColCategsLabelsDrawer";
import {createGridFlexTable} from "../charts/TableAsGridDrawer";
import {drawReport} from "../charts/ReportInDashBoardDrawer";
import {drawCalendar, drawScheduler} from "../charts/FullCalendarDrawer";
import {createHTMLDiv} from "../charts/HTMLDrawer";
import {createHighCombinationChart} from "./HighCombinationChartDrawer";
import {createHighBasicAreaChart} from "./HighBasicAreaChart";
import {createHighGauge} from "./HighGaugeDrawer";
import {createHighColumnRangeChart} from "./HighColumnRangeChartDrawer";
import Highcharts from 'highcharts';
import highcharts3d from 'highcharts/highcharts-3d'
import more from 'highcharts/highcharts-more';
import exporting from 'highcharts/modules/exporting';
import * as cookies from "js-cookie";
import * as HighChartThemes from "../../constants/HighChartsThemes";
import {highChartsDefTheme} from "./themes/HighChartDefaultTheme";
import {highChartsDarkBlueTheme} from "./themes/HighChartDarkBlueTheme";
import {highChartsDarkTheme} from "./themes/HighChartDarkTheme";
import {highChartGridTheme} from "./themes/HighChartGridTheme";
import {highChartsSandTheme} from "./themes/HighChartSandTheme";
import {highChartGrayTheme} from "./themes/HighChartGrayTheme";
import {highChartDarkGreenTheme} from "./themes/HighChartsDarkGreenTheme";
import {highChartDarkUnicaTheme} from "./themes/HighChartsDarkUnicaTheme";
import ChartsThemesContainerTemplate from "../../compiled-templates/ChartsThemesContainerTemplate";
import {getFirstNotNullObj} from "../../common/NamaCommon";
import {translateId} from "../../common/Translator";
import * as ChartsType from "../../constants/ChartsType";
import {NamaRouterInstance} from "../../routing/NamaRouter";
import * as places from "../../routing/places";
import {isMobileDevice} from "../../common/GUIUtilities";
import {createHighStackedAndGroupedColumn} from "./HighStackedAndGroupedColumn";

highcharts3d(Highcharts);
exporting(Highcharts);
more(Highcharts);
let themesMap = new Map();
themesMap.set(HighChartThemes.DarkBlue, highChartsDarkBlueTheme);
themesMap.set(HighChartThemes.DarkTheme, highChartsDarkTheme);
themesMap.set(HighChartThemes.GridTheme, highChartGridTheme);
themesMap.set(HighChartThemes.SandTheme, highChartsSandTheme);
themesMap.set(HighChartThemes.Gray, highChartGrayTheme);
themesMap.set(HighChartThemes.DarkGreen, highChartDarkGreenTheme);
themesMap.set(HighChartThemes.DarkUnica, highChartDarkUnicaTheme);
themesMap.set(HighChartThemes.Default, highChartsDefTheme);

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param {string} h
 * @param {string} w
 * @return {*}
 */
export function drawHighCharts(userDashboardChartLine, h, w, widget) {
    Highcharts.setOptions({
        lang: {
            decimalPoint: '.',
            thousandsSep: ','
        },
        credits: {
            enabled: false
        }
    });
    let chartType = userDashboardChartLine.chartType;
    switch (chartType) {
        case ChartType.PieChart:
            return createHighPieChart(userDashboardChartLine, h, w, false, widget, Highcharts);
        case ChartType.ThreeDPieChart:
            return createHighPieChart(userDashboardChartLine, h, w, true, widget, Highcharts);
        case ChartType.ColumnWithRotatedLabels:
            return createHighColumnsChart(userDashboardChartLine, h, w, widget, Highcharts);
        case ChartType.ColumnWithCategsAndLabels:
            return createHighColCategLabelsChart(userDashboardChartLine, h, w, widget, Highcharts);
        case ChartType.Table:
            return createGridFlexTable(userDashboardChartLine, h, w, widget);
        case ChartType.Report:
            return drawReport(userDashboardChartLine, h, w, widget);
        case ChartType.HTML:
            return createHTMLDiv(userDashboardChartLine, h, w, widget);
        case ChartType.CombinationChart:
            return createHighCombinationChart(userDashboardChartLine, h, w, widget, Highcharts);
        case ChartType.BasicAreaChart:
            return createHighBasicAreaChart(userDashboardChartLine, h, w, widget, Highcharts);
        case ChartType.Gauge:
            return createHighGauge(userDashboardChartLine, h, w, widget, Highcharts);
        case ChartType.ColumnRange:
            return createHighColumnRangeChart(userDashboardChartLine, h, w, widget, Highcharts);
        case ChartType.Calendar:
            return drawCalendar(userDashboardChartLine, h, w, widget);
        case ChartType.ResourceView:
            return drawScheduler(userDashboardChartLine, h, w, widget);
        case ChartType.StackedAndGroupedColumn:
            return createHighStackedAndGroupedColumn(userDashboardChartLine, h, w, widget, Highcharts);
        default:
            break;
    }
}

export function addHighChartsThemes(chartsData, container, highCharts, chartsDrawer) {
    let chartsTypeContainer = $(ChartsThemesContainerTemplate());
    chartsTypeContainer.find("#chartsType").kendoDropDownList({
        dataSource: [ChartsType.Kendo, ChartsType.HighCharts],
        change: (e) => {
            let chartsType = chartsTypeContainer.find("#chartsType").data("kendoDropDownList").value();
            localStorage.setItem("chartsType", chartsType);
            cookies.set("chartsType", chartsType, {expires: 1000});
            chartsDrawer.drawDashBoard(chartsData, true, false);
        }
    });
    if (highCharts) {
        let themesContainer = $(`<div class="col-lg-3 col-md-12 col-sm-12 col-xs-12"><label for="themes" class=" control-label" style="padding-right:10px; padding-left:10px">
        HighCharts Themes</label><input id="themes" value="1"/></div>`);
        chartsTypeContainer.append(themesContainer);
        let chartsType = getFirstNotNullObj(localStorage.getItem("chartsType"), cookies.get("chartsType"));
        chartsTypeContainer.find("#chartsType").data("kendoDropDownList").value(chartsType);
        chartsTypeContainer.find("#themes").kendoDropDownList({
            dataSource: [HighChartThemes.DarkTheme, HighChartThemes.DarkUnica, HighChartThemes.Gray,
                HighChartThemes.Default, HighChartThemes.SandTheme,
                HighChartThemes.GridTheme, HighChartThemes.DarkGreen, HighChartThemes.DarkBlue],
            change: (e) => {
                let themeId = chartsTypeContainer.find("#themes").data("kendoDropDownList").value();
                changeHighChartsTheme(themeId, chartsData, container, chartsDrawer)
            }
        });
        let themeId = getFirstNotNullObj(localStorage.getItem("themeId"), cookies.get("themeId"), HighChartThemes.Default);
        chartsTypeContainer.find("#themes").data("kendoDropDownList").value(themeId);
        switchTheme(themesMap.get(themeId));
    }
    let questionAndParamsDiv = $(`<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12"><a id ="refreshBtn" title=${translateId("refreshWord")} class="k-icon k-i-refresh chartsHeaderBtn"></a><a id ="questionBtn" title=${translateId("parameters")} class="k-icon k-i-redo chartsHeaderBtn"></a><a id = "homeBtn" title=${translateId("homePage")} class='k-button k-button-icon'><span class='fa fa-home'></span></a></div>`);
    let refreshBtn = questionAndParamsDiv.find("#refreshBtn");
    refreshBtn.on("click", (e) => {
        chartsDrawer.drawCharts("", true, false);
    });
    let questionsBtn = questionAndParamsDiv.find("#questionBtn");
    questionsBtn.on("click", (e) => {
        chartsDrawer.showQuestionsPopupPanel();
    });
    let homeBtn = questionAndParamsDiv.find("#homeBtn");
    homeBtn.on("click", (e) => {
        NamaRouterInstance.goTo(new places.WelcomePlace());
    });
    chartsTypeContainer.append(questionAndParamsDiv);
    container.append(chartsTypeContainer);
}

export function changeHighChartsTheme(themeID, chartsData, container, chartsDrawer) {
    localStorage.setItem("themeId", themeID);
    cookies.set("themeId", themeID, {expires: 1000});
    switch (themeID) {
        case HighChartThemes.Default: {
            defaultTheme_();
            break;
        }
        default: {
            switchTheme(themesMap.get(themeID));
            break;
        }
    }
    chartsDrawer.drawDashBoard(chartsData, container)
}

function switchTheme(theme_) {
    Highcharts.charts = [];
    Highcharts.theme = theme_;
    Highcharts.setOptions(Highcharts.theme);
}

function defaultTheme_() {
    Highcharts.theme = highChartsDefTheme;
    Highcharts.setOptions(Highcharts.theme);
}

export function prepareChartData(chartData, w, h) {
    if (isMobileDevice())
        return chartData;
    chartData.width = w;
    chartData.height = h;
    return chartData;
}